import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { AcademyInUseRequest } from "../shared/AcademyInUseRequest";
import { AddAcademyRequest } from "../shared/AddAcademyRequest";
import { DataService_AcademySetup } from "../shared/data.service";

@Component({
	selector: "caass-school-add-academy",
	templateUrl: "./school-add-academy.component.html",
	styleUrls: ["./school-add-academy.component.css"],
})
export class SchoolAddAcademyComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private AcademySetupService: DataService_AcademySetup
	) {}

	ngOnInit(): void {
		//Get data from parent
		this.SchoolID = this.dialogConfig.data.SchoolID;

		//INSERT LOAD COMBO BOX DATA
		this.loadAdminPerson();
	}

	///////////////////////////////////////
	// Data
	///////////////////////////////////////

	errorMessage: any = "";

	//Data from parent
	SchoolID: any;

	//INSERT FORM DATA
	AcademyDesc: any = "";
	AcademyCD: any = "";
	LoadingStaff: boolean = false;
	SelectedStaff: any;
	lstStaff: any = [];

	Processing: boolean = false;

	///////////////////////////////////////

	///////////////////////////////////////
	// Load Data
	///////////////////////////////////////

	//INSERT LOAD DATA METHODS
	loadAdminPerson() {
		this.LoadingStaff = true;

		var result = this.AcademySetupService.LoadStaff(this.SchoolID);
		result.subscribe(
			(response) => {
				this.lstStaff = response;

				this.SelectedStaff = null;

				this.lstStaff.unshift({
					PersonID: -1,
					StaffFullName: "N/A",
				});

				this.SelectedStaff = this.lstStaff[0];

				this.LoadingStaff = false;
			},
			(error) => {
				this.LoadingStaff = false;
			}
		);
	}

	///////////////////////////////////////

	///////////////////////////////////////
	// Buttons
	///////////////////////////////////////

	//INSERT CUSTOM BUTTON METHODS
	onAddAcademy() {
		if (this.AcademyDesc == "") {
			this.errorMessage = "Enter a name";
			return;
		} else if (this.AcademyCD == "") {
			this.errorMessage = "Enter a code";
			return;
		} else {
			this.Processing = true;

			this.CheckName();
		}
	}

	CheckName() {
		let parms: AcademyInUseRequest = {
			str: this.AcademyDesc,
			SchoolID: this.SchoolID,
		};

		var result = this.AcademySetupService.AcademyNameInUse(parms);
		result.subscribe(
			(response) => {
				if (response) {
					this.Processing = false;

					this.errorMessage = "Academy Name Already in Use";
					return;
				} else {
					this.CheckCD();
				}
			},
			(error) => {}
		);
	}

	CheckCD() {
		let parms: AcademyInUseRequest = {
			str: this.AcademyCD,
			SchoolID: this.SchoolID,
		};

		var result = this.AcademySetupService.AcademyCDInUse(parms);
		result.subscribe(
			(response) => {
				if (response) {
					this.Processing = false;

					this.errorMessage = "Academy Abbreviation Already in Use";
					return;
				} else {
					this.FinishAdd();
				}
			},
			(error) => {}
		);
	}

	FinishAdd() {
		let parms: AddAcademyRequest = {
			AcademyCD: this.AcademyCD,
			AcademyDesc: this.AcademyDesc,
			Director_PersonID: this.SelectedStaff.PersonID,
			SchoolID: this.SchoolID,
		};

		var result = this.AcademySetupService.AddAcademy(parms);
		result.subscribe(
			(response) => {
				this.Processing = false;

				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Academy was added successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not add the Academy",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	///////////////////////////////////////

	///////////////////////////////////////
	// Helpers
	///////////////////////////////////////

	IsLoading() {
		return this.LoadingStaff == true || this.Processing == true;
	}

	///////////////////////////////////////
}
